import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {DiscountsService} from "@services";
import {Discount} from "@model";

export const ListOfDiscountsResolver: ResolveFn<Observable<Discount[]> |
  Promise<Discount[]> | Discount[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   discountsService: DiscountsService = inject(DiscountsService)): Observable<Discount[]> |
    Promise<Discount[]> | Discount[] => {
    if (route.queryParams['organiserId']) {
      return discountsService.findDiscounts(+route.queryParams['organiserId'], true);
    } else {
      return discountsService.findDiscounts(undefined, true);
    }
  }
